import moment from 'moment';

export const sortDateDescending = (a: any, b: any) => {
    if (moment(a).isBefore(b)) return 1;
    if (moment(a).isAfter(b)) return -1;
    return 0;
};
